/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_UNDERLYING_ASSET_TYPES(state, data) {
    state.underlyingAssetTypes = data;
  },

};
